import {requirePermission} from '@/modules/auth/permissions'
import {CleanroomScaleProvider} from '@/modules/cleanroom/cleanroom-scale-context'
import {CleanroomSequenceProvider} from '@/modules/cleanroom/cleanroom-sequence-context'
import {CleanroomSequenceWorkflow} from '@/modules/cleanroom/components/cleanroom-sequence-workflow'
import {CleanroomSideNavigation} from '@/modules/cleanroom/components/layout/side-navigation'
import {NoTaskSelected} from '@/modules/cleanroom/components/no-task-selected'
import {useCleanroomCurrentSequence} from '@/modules/cleanroom/hooks/use-cleanroom-current-sequence'
import {CleanroomSearchSchema} from '@/modules/cleanroom/schemas'
import {useSuspenseGetAllProductionLocations} from '@/modules/production/api/use-get-all-production-locations'
import {LoadingLogo} from '@cypro/ui/components/ui/loading-logo'
import {Box} from '@chakra-ui/react'
import {createFileRoute, useNavigate} from '@tanstack/react-router'
import {Suspense, useEffect} from 'react'

export const Route = createFileRoute('/cleanroom/')({
  beforeLoad: requirePermission('production.produce'),
  component: () => {
    return (
      <Suspense fallback={<LoadingLogo minHeight="100dvh" />}>
        <CleanroomRoute />
      </Suspense>
    )
  },
  validateSearch: CleanroomSearchSchema,
})

function CleanroomRoute() {
  const sequence = useCleanroomCurrentSequence()
  const search = Route.useSearch()
  const navigate = useNavigate()

  const [productionLocations] = useSuspenseGetAllProductionLocations()

  useEffect(() => {
    if (!search.productionLocationId) {
      let productionLocationId = sequence?.order?.productionLocationId || productionLocations?.[0]?.id

      if (productionLocationId) {
        navigate({
          to: '/cleanroom',
          search: prev => ({...prev, productionLocationId}),
          replace: true,
          ignoreBlocker: true,
        })
      }
    }
  }, [sequence, productionLocations, search.productionLocationId, navigate])

  return (
    <Box display="flex" width="100%" height="100dvh" flexDirection="row" overflow="hidden">
      <CleanroomSideNavigation />

      <Suspense fallback={<LoadingLogo />}>
        {!sequence && <NoTaskSelected />}

        <CleanroomScaleProvider key={String(search.mockScale)}>
          {sequence && (
            <CleanroomSequenceProvider
              key={`${sequence.id}_${search.workflow}_${search.preparationType}`}
              sequence={sequence}
            >
              <CleanroomSequenceWorkflow />
            </CleanroomSequenceProvider>
          )}
        </CleanroomScaleProvider>
      </Suspense>
    </Box>
  )
}
